exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll-to-top[data-v-6fbdb20e]{position:fixed;right:48px;bottom:48px;display:-webkit-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:36px;height:36px;background-color:#0f9b0d;border-radius:50%;opacity:0}@media (max-width:575.98px){.scroll-to-top[data-v-6fbdb20e]{display:none}}.scroll-to-top.active[data-v-6fbdb20e]{opacity:1}.scroll-to-top[data-v-6fbdb20e]:active,.scroll-to-top[data-v-6fbdb20e]:focus,.scroll-to-top[data-v-6fbdb20e]:focus:active,.scroll-to-top[data-v-6fbdb20e]:hover{background-color:#0d830b}.scroll-to-top i[data-v-6fbdb20e]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fbdb20e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/App/Partials/ScrollToTop.vue
// module id = 201
// module chunks = 35